import { useFormik } from "formik";
import * as Yup from "yup";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useResetPasswordFormik = (opts: {
  onSubmit?: any;
  initialValues?: any;
}) => {
  const { t } = useTranslation("common");

  const memoizedT = useCallback(t, [t]);

  return useFormik({
    initialValues: {
      email: "",
      ...opts?.initialValues,
    },
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .required(memoizedT("resetPassword.form.email.required")) // Translated error message
        .email(memoizedT("resetPassword.form.email.email")), // Translated error message
    }),
    onSubmit: async (values, formikHelpers) => {
      await opts.onSubmit(values, formikHelpers);
    },
  });
};
